export const MIN_TTL = 1;
